import React, { useEffect, useContext } from "react";
import {
  Button,
  Layout,
  Spacing,
  Title,
  Paragraph,
  Meta,
  WithFeedbackProps,
  withFeedback,
} from "@sicredi/react";

import { TextProductDetail } from "#/components/TextProductDetail";
import { useLocation, useNavigate } from "react-router-dom";
import { getProductVisual } from "#/utils/dataForProducts";
import { Footer } from "#/components/Footer";
import { PAGE } from "#/constants";
import { ContextAPI } from "#/contextProver/ContextProver";
import styles from "./styles.module.scss";
import {
  getIdURL,
  navigateSetIdRoute,
} from "#/contextProver/ContextProverServices";
import automovelMobile from "../../assets/automovelMobileDetails.png";

export const ProductDetails: React.FC<WithFeedbackProps> = ({
  setError,
  setSucceeded,
  setException,
  clearFeedback,
}) => {
  const { isMobile, setIdComercial, idComercial, products } =
    useContext(ContextAPI);
  const navigate = useNavigate();
  const { search } = useLocation();
  const idURL = getIdURL(search);
  const currentProduct = products.find(
    (item) => item.idComercial === idComercial
  );
  const visual = getProductVisual(idComercial);
  const imagemDetails =
    Number(idURL) === 1 ? automovelMobile : visual?.imageLarge;

  useEffect(() => {
    if (idURL) {
      setIdComercial(Number(idURL));
    }
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idURL]);

  return (
    <div className={styles.container}>
      <div className={styles.container_view}>
        <Layout.Wrapper>
          <Meta title="Home" />

          <div className={styles.content_part_left_text_button}>
            <div className={styles.container_center}>
              <Title
                as="h1"
                weight="semi-bold"
                className={styles.title_details}
              >
                {currentProduct?.nomeProduto}
              </Title>

              {isMobile && (
                <div className={styles.img_mobile}>
                  <img src={imagemDetails} alt="Imagem do Produto" />
                </div>
              )}
            </div>

            <Spacing appearance="x-small" />
            <Title
              as="h4"
              className={styles.title_color}
              size="medium"
              weight="light"
            >
              Faixa de Crédito
            </Title>

            <Title
              as="h2"
              appearance="primary"
              weight="semi-bold"
              className={styles.title_value}
            >
              {visual?.value}
            </Title>

            <Title
              as="h4"
              className={styles.title_color}
              size="medium"
              weight="light"
            >
              Sujeito a análise de capacidade de pagamento.
            </Title>

            <Spacing appearance="x-small" />

            <Paragraph>
              Após a contemplação, você pode utilizar o consórcio para adquirir:
            </Paragraph>

            <div>
              {visual?.listPossibilities?.map((possibility, index) => (
                <div key={index}>
                  <Spacing appearance="xx-small" />
                  <TextProductDetail>{possibility}</TextProductDetail>
                </div>
              ))}
            </div>

            <Spacing appearance="medium" />

            <div className={styles.button_container}>
              <Button
                className={styles.back_button}
                block
                ghost
                appearance="primary"
                onClick={() => navigate(-1)}
              >
                Voltar
              </Button>

              <Button
                appearance="primary"
                className={styles.button_simular}
                onClick={() =>
                  navigateSetIdRoute({
                    id: idURL,
                    setIdProduto: setIdComercial,
                    navigate,
                    PAGE: PAGE.SIMULATION,
                  })
                }
              >
                Simular
              </Button>
            </div>
          </div>

          {!isMobile && (
            <div className={styles.content_image}>
              <img src={visual?.imageSmall} alt="Imagem do Produto" />
            </div>
          )}
        </Layout.Wrapper>
        <Footer />
      </div>
    </div>
  );
};

export default withFeedback(ProductDetails);
